export const siteSettings = {
  name: "Maple Growth Ltd",
  link: "https://maplegrowthltd.com/",
  email: "support@maplegrowthltd.com/",
  appLink: "https://app.maplegrowthltd.com/",
};
